import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vlf from 'vlf'
import Axios from 'axios'
import iView from 'iview'
import locale from 'iview/dist/locale/en-US'
import VueCookie from 'vue-cookie'
import VueTimeago from 'vue-timeago'
import FBSignInButton from 'vue-facebook-signin-button'
import ReadMore from 'vue-read-more'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueGoodWizard from 'vue-good-wizard';
import MsgBox from '@/helpers/msgBox/index.js';
import SocialSharing from 'vue-social-sharing';
import Meta from 'vue-meta';
import VueProgressiveImage from 'vue-progressive-image'
import './registerServiceWorker'
import AppLayout from '@/layouts/AppLayout'
import Bubble from '@/bubble'
import Ellipsis from '@/ellipsis'
import utils from './utils';
import Cons from '@/constants.json'
import VideoPlayerComponent from '@/components/VideoPlayerComponent'
import AudioPlayerComponent from '@/components/audio/AudioPlayer'
import audio from '@/helpers/audio/audioPauseOthers.js'

import Echo from 'laravel-echo';
import socketIO from 'socket.io-client';
import _get from 'lodash/get'
import IdleJs from 'idle-js';
import { Loader } from '@googlemaps/js-api-loader'
const loader = new Loader({
  apiKey: process.env.VUE_APP_MAPS_API_KEY
});
loader.load()
window.ECHOECHO = Echo;
window.io     = socketIO;
Vue.config.productionTip = false

if(process.env.NODE_ENV === 'production') {
  console.log("%cSTOP", "color: red; font-weight: 700; font-size: 50px;text-shadow: 2px 2px #000; font-family: 'Source Sans Pro', sans-serif");
  console.log(
    "%cThis is a browser feature intended for developers. If someone told you to ",
    "copy and paste something here to enable a site feature or 'hack'' someone's account, ",
    "it is a scam and will give them access to your account. BY MYND-THIRDYKERO ③ ");
  window.console.log = () => {
    window.console.log   = () => {return false;};
    window.console.warn  = () => {return false;};
    window.console.error = () => {return false;};
    window.console.info = () => {return false;};
  };
}

Vue.component('AppLayout', AppLayout)
Vue.component('Bubble', Bubble)
Vue.component('Ellipsis', Ellipsis)
Vue.component('video-player', VideoPlayerComponent)
Vue.component('audio-player', AudioPlayerComponent)
audio.initAudioPauseOthers();

Vue.use(VueProgressiveImage)
Vue.use(VueGoodWizard)
Vue.use(FBSignInButton)
Vue.use(ReadMore)
Vue.use(iView, { locale })

import '@/assets/theme/iview.min.css'
Vue.use(SocialSharing);
Vue.use(Meta)
Vue.use(VueYouTubeEmbed)
Vue.use(Vlf)
Vue.use(VueTimeago, {
  name: 'timeago',
  locale: 'en-US',
  locales: { 'en-US': require('vue-timeago/locales/en-US.json') }
})
Vue.use(MsgBox);

window.BroadcastEvent       = new Vue({})
window.BroadcastOnInvite    = window.BroadcastEvent
window.BroadcastOnShowLike  = window.BroadcastEvent

window.setEvalCookie = function (str) {
  return 'Success'
}

window.initMap = function () {
  store.commit('mapLoaded', true)
}

window.checkReminder = null;
window.checkReminderNotifCookie = null;
window.aInterval = null;
window.activityLoader = null;

window.mobilecheck = function () {
  return utils.checkMobileOS() == 'Android' || utils.checkMobileOS() == 'iOS'
}

window.cookAndServe = ( val ) => {
  // ios purpose to set cookie and fire
  let { token, redirect } = val;
  store.commit('base/setUserAuth', token)
  localStorage.setItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE', JSON.stringify(token))
  
  Axios.defaults.headers.common['Authorization']  = null
  Axios.defaults.headers.common['Authorization']  = 'Bearer ' + token.access_token
  Axios.defaults.headers.put['Content-Type']      = 'application/json'
  Axios.defaults.headers.post['Content-Type']     = 'application/json'
  Axios.defaults.headers.get['Cookie'] = '';
  Axios.defaults.headers.put['Cookie'] = '';
  Axios.defaults.headers.post['Cookie'] = '';
  Axios.defaults.headers.delete['Cookie'] = '';

  store.dispatch('user/getUserInfo').then( res => {
    if ( res.user_type === 'guest' ) 
      router.replace('/home');
    else 
      router.replace(redirect);
  });
}

window.serveAndDine = () => {
  // ios purpose to trigger load me
  store.dispatch('user/getUserInfo');
}

window.idle = null;
window.idleTimeUpdate = (params) => {
  if(VueCookie.get("os_type") === "ios") return false;

  let idleTime = 15000 * 60;
  if ( params && _get(params, "minutes") > 0 ) {
    idleTime = (params.minutes * 60) * 1000
  }

  window.idle = new IdleJs({
    idle: idleTime, // idle time in ms
    events: ['mousemove', 'keydown', 'mousedown', 'touchstart'], // events that will trigger the idle resetter
    onIdle: () => {
      if( _get( store.state.user.info, "user_type", "guest") !== "guest" ) {
        console.log("TRIGGER AUTO LOGOUT")
        store.dispatch('base/signout', null, {root: 1})
          .then(() => {
            if(VueCookie.get("os_type") === "ios")  {
              window.webkit.messageHandlers.onNativeCalled.postMessage({
                name: 'authLogoutIdle',
                params: {}
              })
            } else {
              router.replace(`/${router.currentRoute.params.brandSlug}/login`);
            }
          })
      }
    }, // callback function to be executed after idle time
    onActive: () => {
      console.log("Active")
    }, // callback function to be executed after back form idleness
    onHide: () => {
      console.log("On Hide")
    }, // callback function to be executed when window become hidden
    onShow: () => {
      console.log("On show")
    }, // callback function to be executed when window become visible
    keepTracking: true, // set it to false if you want to be notified only on the first idleness change
    startAtIdle: false // set it to true if you want to start in the idle state
  })

  window.idle.start();
} 

let v = new Vue({
  router,
  store,
  data() {
    return {
      userAgent: utils.identifyBrowser()
    }
  },
  created() {
    window.addEventListener('beforeunload', this.handler)
    if("brandSlug" && this.$route.params &&  this.$route.params.brandSlug ) {
      Cons[0].PATHS.BRAND = this.$route.params.brandSlug + "_";
    } else {
      Cons[0].PATHS.BRAND = "GENERIC_"

      let ecosys = JSON.parse(VueCookie.get("CURRENT_BRAND_SLUG")) || process.env.VUE_APP_DEV_ECOSYSTEM
      this.$router.push("/"+ecosys)
      location.reload();
    }

    // handle old cookie token here
    let oldCookie = VueCookie.get(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
    if (oldCookie) {
      localStorage.setItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE', oldCookie)
      VueCookie.delete(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
    }
    // end of old cookie migration

    let mCookie = localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
    let uCookie = JSON.parse(mCookie)

    if (uCookie){
      Axios.defaults.headers.common['Authorization']  = null
      Axios.defaults.headers.common['Authorization']  = 'Bearer ' + uCookie.access_token
      Axios.defaults.headers.put['Content-Type']      = 'application/json'
      Axios.defaults.headers.post['Content-Type']     = 'application/json'
    }
  },
  mounted () {
    utils.configureMessage()

    var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS');
    if (window.matchMedia('(display-mode: standalone)').matches || ( ("standalone" in window.navigator) && window.navigator.standalone )) {
      this.$store.commit('base/showPWAInstallation', false);
      this.$store.commit('base/setShowInstallApp', false);
    } else {
      if( window.mobilecheck() && isSafari) {
        this.$store.commit('base/showPWAInstallation', true);
      } else if( window.mobilecheck() && this.userAgent.chrome ) {
        this.$store.commit('base/setShowInstallApp', true);
      }
    }

    store.commit('isMobile', window.mobilecheck())

    if (this.$route.path !== '/preview' && localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')) {
      console.log("WITH COOKIE")
      let mCookie = localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
      let uCookie = JSON.parse(mCookie)
      Axios.defaults.headers.common['Authorization']  = null
      Axios.defaults.headers.common['Authorization']  = 'Bearer ' + uCookie.access_token
      Axios.defaults.headers.put['Content-Type']      = 'application/json'
      Axios.defaults.headers.post['Content-Type']     = 'application/json'
      store.commit('base/setUserAuth', uCookie)
      store.dispatch('user/getUserInfo').then( res => {
        store.dispatch("points/setUserActionPoints", {
          action: "open_app"
        }, {root: 1})
      })
    } else if (this.$route.path === '/preview' && localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')) {
      console.log("PREVIEW : WITH COOKIE")
      let mCookie = localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
      let uCookie = JSON.parse(mCookie)
      Axios.defaults.headers.common['Authorization']  = null
      Axios.defaults.headers.common['Authorization']  = 'Bearer ' + uCookie.access_token
      Axios.defaults.headers.put['Content-Type']      = 'application/json'
      Axios.defaults.headers.post['Content-Type']     = 'application/json'
      store.commit('base/setUserAuth', uCookie)
      store.dispatch('user/getUserInfo')
    } else if (this.$route.path === '/preview' && !localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')) {
      console.log("PREVIEW : WITHOUT COOKIE")
      store.dispatch('base/eventHit', {eventCategory:'/preview',eventAction:"guest login" +' - /preview - main',eventLabel:'guest login'})
      this.$store.dispatch("guest/registerGuest", null, {root:1})
        .then(res => {
          this.$router.replace(`/${this.$route.params.brandSlug}/login?type=signin`)
        });  
    } else {
      console.log("WITHOUT COOKIE")
      if (localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')) {
        let mCookie = localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
        let uCookie = JSON.parse(mCookie)
        Axios.defaults.headers.common['Authorization']  = null
        Axios.defaults.headers.common['Authorization']  = 'Bearer ' + uCookie.access_token
        Axios.defaults.headers.put['Content-Type']      = 'application/json'
        Axios.defaults.headers.post['Content-Type']     = 'application/json'
        store.commit('base/setUserAuth', uCookie)
        store.dispatch('user/getUserInfo')
          .then( res => {
            if(res.user_type === 'guest')
              this.$router.replace(`/${this.$route.params.brandSlug}/login?type=signin`)
          })
      } else {
        this.$store.dispatch("guest/registerGuest", null, {root:1})
          .then(res => {
            if (
              this.$route.name !== "Preview" &&
              this.$route.name !== "Brand Preview" &&
              this.$route.meta.auth == 1
            )
              this.$router.replace(
                `/${this.$route.params.brandSlug}/login?type=signin`
              );
          });   
      }
      store.dispatch('base/eventHit', {eventCategory:'/preview',eventAction:"guest login" +' - /preview - main',eventLabel:'guest login'})
      // this.$store.dispatch('base/authenticate', {response: {password: 'Sharp3nGu3st', email: 'guest'}, reroute: 1})
      this.$store.dispatch("guest/registerGuest", null, {root:1});
    }

    this.$vlf.createInstance({
      storeName: 'humanity'
    }).then( s => {
      s.getItem('code').then(code=> {
        s.getItem('isVerified').then(verified=> {
          s.getItem('mobile').then(mobile=> {
            store.commit('base/setVCodeMobile', mobile)
            store.commit('base/setVCode', code)
            store.commit('base/setVCodeVerified', verified)
          })
        })
      })
    })

    this.$store.dispatch('getActionMenu', null, {root:1});
  },
  render: h => h(App)
}).$mount('#app')
